import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowedUsers } from "src/contexts"
import { useUpdateDeviceSettings } from "src/hooks/deviceSettings"

export function useUpdateInsights() {
  const { currentDeviceSettings } = useFollowedUsers()
  const id = currentDeviceSettings.id

  const updateDeviceSettings = useUpdateDeviceSettings()

  const updateInsight = useMemo(
    () => !updateDeviceSettings ? undefined : (newInsights: Array<Insight>) => {
      const data = {
        id,
        insights: newInsights,
      }

      return updateDeviceSettings(data)
    },
    [
      id,
      updateDeviceSettings,
    ],
  )

  return updateInsight
}
